import { FilterChip } from '@marqvision/shared';
import { useGetFilterParams, usePathParams } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';

export const InfringingImageFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { params, setParams, removeParams } = useGetFilterParams();
  const { page, listingStatus } = usePathParams();
  const { amplitudeLogging } = useLogger();

  const isSelected = Boolean(params.infringing_images_filter);

  const handleToggle = () => {
    amplitudeLogging('applied filter', {
      Type: 'infringing_images_filter',
      Channel: page,
      Page: getListingTabGroup(listingStatus),
    });

    if (isSelected) {
      removeParams(['infringing_images_filter']);
    } else {
      setParams({ infringing_images_filter: true }, { replace: true });
    }
  };

  return (
    <FilterChip type="toggle" label="Infringing image used" selected={isSelected} size={size} onClick={handleToggle} />
  );
};
